import React from 'react';

import './FloorPlanLegend.css';

import { TableRectangularIcon } from '../../ui/icons/TableRectangularIcon';

import { GUEST_OPEN_ICON_STYLE, TABLE_TONE_TEXT } from './tableToneColors';

const BORDER_ITEMS = [
  { color: 'var(--color-success-500)', label: 'Вы участвуете' },
  { color: 'var(--color-warning-500)', label: 'Ждёт вашего ответа' },
  { color: 'var(--color-wood-600)', label: 'Вы не участвуете' },
];

const FILL_ITEMS = [
  { color: TABLE_TONE_TEXT.open, example: '3/6', label: 'Открытое, есть места' },
  { color: TABLE_TONE_TEXT.private, example: '3/6', label: 'Приватное' },
  { color: TABLE_TONE_TEXT.full, example: '6/6', label: 'Мест нет' },
];

/** Маленькая кнопка «ⓘ», по нажатию открывает модальное окно с обозначениями на плане. */
export function FloorPlanLegend() {
  const [open, setOpen] = React.useState(false);
  const close = React.useCallback(() => setOpen(false), []);

  React.useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, close]);

  return (
    <>
      <button
        type="button"
        className="ttbFloorPlanLegendButton"
        onClick={() => setOpen(true)}
        aria-label="Обозначения на плане"
        aria-haspopup="dialog"
      >
        i
      </button>

      {open ? (
        <div className="tavern-modal-overlay" onClick={close}>
          <div
            className="tavern-modal ttbFloorPlanLegend"
            role="dialog"
            aria-modal="true"
            aria-label="Обозначения на плане"
            onClick={(e) => e.stopPropagation()}
          >
            <button type="button" className="ttbFloorPlanLegendCross" onClick={close} aria-label="Закрыть">
              ×
            </button>
            <h2 className="tavern-modal-title">Обозначения</h2>

            <div className="ttbFloorPlanLegendGroup">
              <div className="ttbFloorPlanLegendGroupTitle">Рамка — ваше участие</div>
              <ul className="ttbFloorPlanLegendList">
                {BORDER_ITEMS.map((item) => (
                  <li key={item.label} className="ttbFloorPlanLegendItem">
                    <svg className="ttbFloorPlanLegendTable" width="46" height="32" viewBox="0 0 66 46" aria-hidden="true">
                      <rect
                        x="1.5"
                        y="1.5"
                        width="63"
                        height="43"
                        rx="10"
                        fill="rgba(245, 239, 231, 0.9)"
                        stroke={item.color}
                        strokeWidth="3"
                      />
                      <g transform="translate(13, 3)">
                        <TableRectangularIcon width="40" height="40" />
                      </g>
                    </svg>
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>

            <div className="ttbFloorPlanLegendGroup">
              <div className="ttbFloorPlanLegendGroupTitle">Дробь у стола — занято/всего мест</div>
              <ul className="ttbFloorPlanLegendList">
                {FILL_ITEMS.map((item) => (
                  <li key={item.label} className="ttbFloorPlanLegendItem">
                    <span className="ttbFloorPlanLegendFraction" style={{ color: item.color }}>
                      {item.example}
                    </span>
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>

            <div className="ttbFloorPlanLegendGroup">
              <div className="ttbFloorPlanLegendGroupTitle">Гостевой доступ</div>
              <ul className="ttbFloorPlanLegendList">
                <li className="ttbFloorPlanLegendItem">
                  <svg width="28" height="28" viewBox="0 0 40 40" aria-hidden="true">
                    <g style={GUEST_OPEN_ICON_STYLE}>
                      <TableRectangularIcon width="40" height="40" />
                    </g>
                  </svg>
                  Стол открыт для гостей в выбранный день
                </li>
              </ul>
              <p className="ttbFloorPlanLegendNote">
                Обычно мероприятия создают только организаторы и админы. Когда админ открывает гостевой доступ,
                любой участник клуба, в том числе гость, может создать мероприятие на отмеченных столах в указанные день и время.
              </p>
            </div>

            <div className="tavern-modal-actions">
              <button type="button" className="ttbFloorPlanLegendClose" onClick={close}>
                Понятно
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
